import React, { createContext, useCallback, useEffect, useState } from 'react'
import { Box, CircularProgress, Stack, Typography } from '@mui/material'
import ButtonDefault from '../ButtonDefault'
import { FormattedMessage, useIntl } from 'react-intl'
import { useBreakpoints } from '../breakpoints/BreakpointsProvider'
import appConst from '../../constant/appConstants'
import Popup from '../Popup'

const APPLE_URL = 'https://apps.apple.com/fr/app/gerep/id482050275'
const PLAYSTORE_URL = 'https://play.google.com/store/apps/details?id=com.gerepmobile.prod&hl=fr&gl=US'
const deepLink = appConst.deepLink
const isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent)

const RedirectionMobileContext = createContext({})

type RedirectionMobileProviderProps = {
	children: React.ReactNode
}

const RedirectionMobileProvider: React.FC<RedirectionMobileProviderProps> = ({
	children
}) => {
	const intl = useIntl()
	const { isMobile, isTabletPortrait } = useBreakpoints()
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const [open, setOpen] = useState<boolean>(isMobile) // !permanentClose &&

	const rediriger = useCallback(() => {
		if (deepLink) {
			window.location.href = deepLink
			setIsLoading(true)
			setTimeout(() => {
				window.open(isIOS ? APPLE_URL : PLAYSTORE_URL)
				setIsLoading(false)
			}, 3000)
		} else {
			window.open(isIOS ? APPLE_URL : PLAYSTORE_URL)
		}
	}, [])

	/*
	const [permanentClose, setPermanentClose] = useState<boolean>(() => {
		return localStorage.getItem('closeLiensUniversels') === 'true'
	})
	const onPermanentClose = useCallback((check: boolean) => {
		if (check) {
			localStorage.setItem('closeLiensUniversels', 'true')
			setPermanentClose(true)
		}
		setOpen(false)
	}, [])*/

	useEffect(() => {
		if (isMobile) { // !permanentClose &&
			setOpen(true)
			// localStorage.setItem('closeLiensUniversels', 'false')
		}
	}, [isMobile])

	return (
		<RedirectionMobileContext.Provider value={{}}>
			{children}
			{open && (
				<Popup
					open={open}
					setOpen={setOpen}
					title={intl.formatMessage({ id: 'login.popinToApp.title' })}
					onClose={() => setOpen(false)}
				>
					<Stack direction="column" spacing="12px">
						<Box>
							<Stack direction="column" spacing="16px" alignItems="center">
								<Typography variant="body2" fontSize="0.875rem">
									{intl.formatMessage({ id: 'login.popinToApp.appDetected' })}
								</Typography>

								<Stack direction={isTabletPortrait ? 'row' : 'column'} spacing="12px">
									<ButtonDefault variant="contained" onClick={rediriger}>
										{isLoading ? <CircularProgress size={24} color="inherit" /> : <FormattedMessage id="login.popinToApp.goToGerepMobile" />}
									</ButtonDefault>
									<ButtonDefault variant="outlined" onClick={() => setOpen(false)}>
										{intl.formatMessage({ id: 'login.popinToApp.stayWeb' })}
									</ButtonDefault>
								</Stack>
							</Stack>
						</Box>
					</Stack>
				</Popup>
			)}
		</RedirectionMobileContext.Provider>
	)
}

export default RedirectionMobileProvider